export const ADDRESS_RIGHT = {
  BASE_URL: "https://www.addressright.co.nz",
  API_KEY: "333093_Q5wdTu6YcsWhyRTu",
};

export const AWS_API = {
  AWS_ACCESS_KEY_ID: `AKIA4GGWYOEX32X3Q2XK`,
  AWS_SECRET_ACCESS_KEY: `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`,
  AWS_DEFAULT_REGION: `ap-southeast-2`,
  AWS_BUCKET_NAME: `pie-club`,
};

export const ENCRYPT_KEY = "pie-club-admin";
